$(document).ready(function(e) {

	
	$('ul.mainMenu li a').click(function(event) {
		event.preventDefault();
		var ids = $(this).attr('href');
		 $('html, body').animate({
			scrollTop: $(ids).offset().top - 50
		}, 2000);
	});
	
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#getOrder").offset().top
		}, 2000);
	});
	
	$(".ing_scorall").click(function () {
		var offsetValue = ($(window).width() <= 767) ? 0 : 40;
	
		$('html, body').animate({
			scrollTop: $("#getfulling").offset().top - offsetValue
		}, 2000);
	});
	
		
	$('.head_strip_list').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: false,
		variableWidth: true,
		centerMode: true,
		autoplaySpeed: 0,
		speed: 6000,
		cssEase: 'linear',
		pauseOnHover: false,
		pauseOnFocus: false,
		infinite: true,
		responsive: [
		 
		 {
			breakpoint: 9999,
			settings:"unslick"
		},
				
		 {
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		}
		]
	});	
	
	$('.prd-sldr').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows:true,
		asNavFor: '.thumb-sldr',
		autoplay: false,
		autoplaySpeed: 11000,
		dots: false,
	});
	
	$('.thumb-sldr').slick({
		slidesToShow:5,
		slidesToScroll: 1,
		asNavFor: '.prd-sldr',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		infinite: true,
		arrows: false,
		rtl: false, 
	});	
		
	$('.purchase_box').click(function(e) {
		$('.purchase_box').removeClass('active');
		$(this).addClass('active');		
	});
	
    // $('.buyopt').click(function(){
    //     $('.buyopt').removeClass('active');
    //     $(this).addClass('active');	
    // });	

    // function syncBuyOptUI() {
    //   const isSubs = $('.buyopt.subs').hasClass('active');
    //   const isOtp  = $('.buyopt.otp').hasClass('active');

    //   if (isSubs) {
    //     $('.buyopt.--subs').show();
    //     $('.buyopt.--otp').hide();
    //   } else if (isOtp) {
    //     $('.buyopt.--otp').show();
    //     $('.buyopt.--subs').hide();
    //   } else {
    //     // optional fallback if nothing is active
    //     $('.buyopt.--subs, .buyopt.--otp').hide();
    //   }
    // }

    // $(document).on('click', '.buyopt.subs, .buyopt.otp', function () {
    //   $('.buyopt.subs, .buyopt.otp').removeClass('active');
    //   $(this).addClass('active');
    //   syncBuyOptUI();
    // });

    // // run once on page load to match the default active state
    // $(document).ready(syncBuyOptUI);


(function ($) {

  // Identify each switch-opt as a "buyopt group"
  function getGroups() {
    return $('.switch-opt').has('.buyopt.subs, .buyopt.otp');
  }

  function setBuyOpt(mode) {
    // mode: 'subs' or 'otp'
    const groups = getGroups();

    groups.each(function () {
      const $group = $(this);
      const $subsBox = $group.find('.buyopt.subs');
      const $otpBox  = $group.find('.buyopt.otp');

      const $subsRadio = $subsBox.find('input[type="radio"]');
      const $otpRadio  = $otpBox.find('input[type="radio"]');
      const isSubs = $('.buyopt.subs').hasClass('active');
      const isOtp  = $('.buyopt.otp').hasClass('active');

      if (mode === 'subs') {
        $subsBox.addClass('active');
        $otpBox.removeClass('active');

        $subsRadio.prop('checked', true).trigger('change');
        $otpRadio.prop('checked', false).trigger('change');
        $('.buyopt.--subs').show();
        $('.buyopt.--otp').hide();
      } else {
        $('.buyopt.--otp').show();
        $('.buyopt.--subs').hide();
        $otpBox.addClass('active');
        $subsBox.removeClass('active');

        $otpRadio.prop('checked', true).trigger('change');
        $subsRadio.prop('checked', false).trigger('change');
      }
    });
  }

  // Click on the whole card toggles, and syncs BOTH groups
  $(document).on('click', '.switch-opt .buyopt.subs, .switch-opt .buyopt.otp', function (e) {
    // If user clicked directly on the input, let it behave normally too
    const mode = $(this).hasClass('subs') ? 'subs' : 'otp';
    setBuyOpt(mode);
  });

  // If user clicks the radio itself, also sync
  $(document).on('change', '.switch-opt input[type="radio"][name="buyopt"]', function () {
    const mode = $(this).closest('.buyopt').hasClass('subs') ? 'subs' : 'otp';
    setBuyOpt(mode);
  });

  // Initial sync on load: prefer whatever is checked, else whatever is active
  $(function () {
    const $checked = $('.switch-opt input[type="radio"][name="buyopt"]:checked').first();
    if ($checked.length) {
      const mode = $checked.closest('.buyopt').hasClass('subs') ? 'subs' : 'otp';
      setBuyOpt(mode);
      return;
    }

    const isSubsActive = $('.switch-opt .buyopt.subs.active').length > 0;
    setBuyOpt(isSubsActive ? 'subs' : 'otp');
  });

})(jQuery);




	

$('.power_ingred_blk').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  responsive: [
		// <= 1730px
		{
		breakpoint: 1730,
		settings: { slidesToShow: 5, dots: true, arrows: false }
		},
		// <= 1430px
		{
		breakpoint: 1430,
		settings: { slidesToShow: 4, dots: true, arrows: false }
		},
		// <= 1021px
		{
		breakpoint: 1021,
		settings: { slidesToShow: 3, dots: true, arrows: false }
		},
		// <= 767px
		{
		breakpoint: 767,
		settings: {
			slidesToShow: 1,
			centerMode: true,
			variableWidth: true,
			dots: true,
			arrows: true
		}
		},
		// <= 390px
		{
		breakpoint: 390,
		settings: {
			slidesToShow: 1,
			centerMode: true,
			variableWidth: false,
			dots: true,
			arrows: false
		}
		}
	]
});

	
	
	$('.testi_box').slick({
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 1,				
		autoplay: false,
		arrows:true,
		dots:true,
		responsive: [
		 
		 {
			breakpoint: 1021,
			settings: {
				slidesToShow:2,
			}
		},
				
		 {
			breakpoint: 767,
			settings: {
				slidesToShow:1,
				slidesToScroll: 1,
				centerMode: true,
				variableWidth: true,
				arrows:false,
			}
		}
		]
	});		
	
			
	//accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	

	<!--Mobile-->
	$(".continue_btn").click(function(e){
        e.preventDefault();

        $(this).hide();  // continue button remove

        $(".bundle_details").show(); // bundle details open
	
    });

});


document.addEventListener("DOMContentLoaded", () => {

    const packageBoxes = document.querySelectorAll(".package_box");

    // Desktop & Mobile selectors
    const desktopLis = document.querySelectorAll(".prod_addition li");
    const desktopProdNo = document.querySelector(".prod_no");

    const mobileLis = document.querySelector(".bundle_sticky_wrap .prod_addition") 
                        ? document.querySelectorAll(".bundle_sticky_wrap .prod_addition li")
                        : [];
    const mobileProdNo = document.querySelector(".bundle_sticky_wrap .prod_no");

    const bundleSticky = document.querySelector(".bundle_sticky_wrap");

    const selectTextDesktop = document.querySelector(".bundle_box-desk .select_text");
    const selectTextMobile  = document.querySelector(".bundle_box-mob .select_text");
	const box2btn  = document.querySelector(".ta-box-b .btnatc");

    const MAX_TOTAL = 4;

    // Get total qty
    function getTotalQty() {
        let total = 0;
        document.querySelectorAll(".qty_num").forEach(q => {
            total += parseInt(q.textContent);
        });
        return total;
    }

    // Update remaining slot text
    function updateProdNo() {
		let totalSelected = getTotalQty();
		let remaining = MAX_TOTAL - totalSelected;
	
		if (desktopProdNo) desktopProdNo.textContent = remaining;
		if (mobileProdNo) mobileProdNo.textContent = remaining;
	
		handleSelectTextVisibility(remaining);
		handlePlusButtonState(remaining);
	
		// NEW: mobile continue button & sticky class
		handleMobileContinue(totalSelected);
	}

    // Hide/show select_text based on remaining count
    function handleSelectTextVisibility(remaining) {
		
        if (remaining === 0) {
            if (selectTextDesktop) selectTextDesktop.style.display = "none";
            if (selectTextMobile) selectTextMobile.style.display = "none";
			box2btn.style.display = "block";
        } else {
			box2btn.style.display = "none";
            if (selectTextDesktop) selectTextDesktop.style.display = "block";
            if (selectTextMobile) selectTextMobile.style.display = "block";
        }
    }

    // Disable/enable all + buttons
    function handlePlusButtonState(remaining) {
        const allPlusBtns = document.querySelectorAll(".plus_btn");

        allPlusBtns.forEach(btn => {
            if (remaining === 0) {
                btn.disabled = true;
                btn.classList.add("disabled_plus");
            } else {
                btn.disabled = false;
                btn.classList.remove("disabled_plus");
            }
        });
    }

    // // Update right side image list in desktop + mobile
    // function updateRightList(imgSrc, qty) {

    //     function applyToList(list) {
    //         if (!list) return;

    //         list.forEach(li => {
    //             const img = li.querySelector("img");
    //             if (img && img.src === imgSrc) li.textContent = "+";
    //         });

    //         let added = 0;
    //         for (let li of list) {
    //             if (li.textContent.trim() === "+" && added < qty) {
    //                 li.innerHTML = `<img src="${imgSrc}" />`;
    //                 added++;
    //             }
    //         }
    //     }

    //     applyToList(desktopLis);
    //     applyToList(mobileLis);
    // }

	// Update right side image list in desktop + mobile
	function updateRightList(imgSrc, qty, variantId, subId) {
		function applyToList(list) {
			if (!list) return;

			const v = String(variantId ?? "");
			const s = String(subId ?? "");

			// Clear only images that match BOTH variant + subId
			list.forEach(li => {
			const img = li.querySelector("img");
			if (!img) return;

			const liVarId = String(img.dataset.varid ?? "");
			const liSubId = String(img.dataset.subid ?? "");

			if (liVarId === v && liSubId === s) {
				li.textContent = "+";
			}
			});

			// Fill qty slots for this variant/sub combo
			let added = 0;
			for (const li of list) {
			if (li.textContent.trim() === "+" && added < qty) {
				li.innerHTML = `<img data-varid="${v}" data-subid="${s}" src="${imgSrc}" />`;
				added++;
			}
			}
		}

		applyToList(desktopLis);
		applyToList(mobileLis);
	}


    // Check empty for desktop list
    function hasEmptySlot() {
        return Array.from(desktopLis).some(li => li.textContent.trim() === "+");
    }

    packageBoxes.forEach(box => {
        const addBtn = box.querySelector(".pkg_btn");
        const qtyBox = box.querySelector(".qty_box");
        const plusBtn = box.querySelector(".plus_btn");
        const minusBtn = box.querySelector(".minus_btn");
        const qtyNum = box.querySelector(".qty_num");
		const prodImgEl = box.querySelector(".pkg_products");
		const prodImg   = prodImgEl?.src;
		const variantId = prodImgEl?.dataset.varid;
		const varsubtId = prodImgEl?.dataset.subid;

        // Click "Add To Bundle"
        addBtn.addEventListener("click", e => {
			e.preventDefault();
		
			let total = getTotalQty(); 
		
			// STOP if already 4 selected
			if (total >= MAX_TOTAL) return;
		
			addBtn.style.display = "none";
			qtyBox.style.display = "flex";
		
			// set quantity to 1
			qtyNum.textContent = 1;
			minusBtn.classList.remove("color_btn");
		
			updateRightList(prodImg, 1, variantId, varsubtId);
			updateProdNo();
		
			// activate mobile sticky
			if (bundleSticky) bundleSticky.classList.add("active");
		});

        // PLUS button
        plusBtn.addEventListener("click", () => {
            let qty = parseInt(qtyNum.textContent);
            let total = getTotalQty();

            if (total >= MAX_TOTAL) return;
            if (!hasEmptySlot()) return;

            qty++;
            qtyNum.textContent = qty;
            minusBtn.classList.remove("color_btn");

            updateRightList(prodImg, qty, variantId, varsubtId);
            updateProdNo();

            if (bundleSticky) bundleSticky.classList.add("active");
        });

        // MINUS button
        minusBtn.addEventListener("click", () => {
            let qty = parseInt(qtyNum.textContent);

            if (qty > 0) qty--;

            qtyNum.textContent = qty;

            if (qty === 0) {
                minusBtn.classList.add("color_btn");
            }

            updateRightList(prodImg, qty, variantId, varsubtId);
            updateProdNo();

            if (getTotalQty() === 0 && bundleSticky) {
                bundleSticky.classList.remove("active");
            }
        });

    });
	
	function handleMobileContinue(totalSelected) {
		const continueBtn = document.querySelector(".bundle_sticky_wrap .continue_btn");
	
		if (!continueBtn || !bundleSticky) return;
	
		if (totalSelected === 4) {
			continueBtn.style.display = "flex"; 
		} else {
			continueBtn.style.display = "none";
			bundleSticky.classList.remove("sticky_wrap-full");
		}
		
		
		const mobileContinueBtn = document.querySelector(".bundle_sticky_wrap .continue_btn");

		if (mobileContinueBtn) {
			mobileContinueBtn.addEventListener("click", () => {
				bundleSticky.classList.add("sticky_wrap-full");
			});
		}
	}
	

    // Initialize status
    updateProdNo();
	
	
	// ============ BACK BUTTON RESET ============ //

	$(".back_btn").on("click", function () {

		// 1. Hide sticky wrapper states
		$(".bundle_sticky_wrap").removeClass("sticky_wrap-full");
	
		// 2. Reset the product count number to default (4)
		$(".prod_no").text("4");
		totalSelected = 0;  // reset your JS counter
	
		// 3. Reset quantity UI
		$(".qty_num").text("0");
		$(".qty_box").hide();        // hide qty counters
		$(".pkg_btn").show();        // show "Add" or package button again
	
		// 4. Reset product cards
		$(".product_box").removeClass("added active");
		$(".pkg_btn").removeClass("disabled");
		$(".add_btn").removeClass("disabled");
	
		// 5. Reset selector text
		$(".select_text").show();
	
		// 6. Hide continue button
		$(".continue_btn").removeClass("show");
		$("body").removeClass("sticky_wrap-full");
	
		// 7. Hide bundle details
		$(".bundle_details").hide();
	
		// 8. Reset prod_addition (all back to "+")
		$(".prod_addition li").html("+").removeClass("filled");
		$(".prod_addition").removeClass("complete");

	});

});


$(window).on("scroll", function () {

    if ($(window).width() < 768) {   // mobile only
        let scrollTop = $(window).scrollTop();
        let sec1Top = $("#getBundle").offset().top;   // show earlier
        let sec1Bottom = sec1Top + $("#getBundle").outerHeight() - 50; // hide later 270

        if (scrollTop >= sec1Top && scrollTop <= sec1Bottom){
            $(".bundle_sticky_wrap").addClass("active");
        } else {
            $(".bundle_sticky_wrap").removeClass("active");
        }
    }
});


$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}

	$(document).on('click', 'a.j-go-slide', function (e) {
        e.preventDefault();
        $('.prd-sldr').slick('slickGoTo', 2);
    });
});

$(document).on('click', '.add_cart_btn.mob-btncta', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const btn = document.querySelector('.ta-box-b .btnatc');
  const loader = document.querySelector('.ta-box-b .c-loader');
  if (!btn) return;

  if (typeof window.addToCartThenCheckout === 'function') {
    window.addToCartThenCheckout(btn, loader);
  } else {
    btn.click();
  }
});
